import { ScatterPlot } from './ScatterPlot';
import { ReportActions, ReportActionData } from './ReportActions';
import { Report } from '../../types/report.types';
import { DataSet, ColumnId } from '../../types';
import { getColumnNameById } from '../utils/column-utils';

/**
 * ScatterPlotWithReportActions - レポート機能付き散布図
 *
 * 散布図にレポート作成・追加機能を合成したコンポーネント
 * - 右クリックでコンテキストメニューから追加可能
 */

interface ScatterPlotWithReportActionsProps {
  dataset: DataSet;
  xColumn: ColumnId;
  yColumn: ColumnId;
  filteredRowIndices?: number[] | null;
  selectedRows?: number[];
  width?: number;
  height?: number;
  onPointClick?: (dataIndices: number[], isAdditive?: boolean) => void;
  // レポート機能用
  availableReports: Report[];
  onAddToReport: (reportId: string, data: ReportActionData) => void;
  onCreateNewReport: (data: ReportActionData) => void;
}

export function ScatterPlotWithReportActions({
  dataset,
  xColumn,
  yColumn,
  filteredRowIndices,
  selectedRows,
  width,
  height,
  onPointClick,
  availableReports,
  onAddToReport,
  onCreateNewReport
}: ScatterPlotWithReportActionsProps) {
  // 列IDから列名を取得してタイトルに使用
  const xColumnName = getColumnNameById(dataset, xColumn) || xColumn;
  const yColumnName = getColumnNameById(dataset, yColumn) || yColumn;

  // 散布図用のアクションデータを作成
  const actionData: ReportActionData = {
    type: 'scatter_plot',
    title: `Scatter Plot: ${xColumnName} vs ${yColumnName}`,
    scatterPlotData: {
      xColumn,
      yColumn,
      dataset
    }
  };

  return (
    <ReportActions
      availableReports={availableReports}
      onAddToReport={onAddToReport}
      onCreateNewReport={onCreateNewReport}
      actionData={actionData}
    >
      <ScatterPlot
        dataset={dataset}
        xColumn={xColumn}
        yColumn={yColumn}
        filteredRowIndices={filteredRowIndices}
        selectedRows={selectedRows}
        width={width}
        height={height}
        onPointClick={onPointClick}
      />
    </ReportActions>
  );
}
